import { Button } from "@mui/material";
import { colorSecondary, darkenColor, lightenColor } from "@/constants/colors";
import { Hint } from "@/HOC";
import { TCustomButtonProps } from "./CustomButton.props";

const CustomButton = ({ hint = "", hintPosition, ...props }: TCustomButtonProps): JSX.Element => {
	return (
		<Hint hint={hint} position={hintPosition} width={props.fullWidth ? "100%" : undefined}>
			<Button
				variant="outlined"
				type="button"
				{...props}
				sx={{
					fontFamily: "inherit",
					fontSize: 11,
					fontStyle: "inherit",
					fontWeight: "inherit",
					lineHeight: "inherit",
					letterSpacing: "inherit",
					overflow: "hidden",

					// переопределение mui-primary цвета
					".MuiButton-colorPrimary&:not(.Mui-disabled)": {
						// для outlined
						"&.MuiButton-outlined": {
							color: colorSecondary,
							borderColor: lightenColor(colorSecondary, "50%"),

							"&:hover": {
								borderColor: "inherit",
								backgroundColor: lightenColor(colorSecondary, "90%"),
							},
						},

						// для contained
						"&.MuiButton-contained": {
							backgroundColor: colorSecondary,

							"&:hover": {
								backgroundColor: darkenColor(colorSecondary, "10%"),
							},
						},

						// для text
						"&.MuiButton-text": {
							color: colorSecondary,

							"&:hover": {
								backgroundColor: lightenColor(colorSecondary, "90%"),
							},
						},
					},

					...props.sx,
				}}
			/>
		</Hint>
	);
};

export default CustomButton;
